module.exports = __webpack_public_path__ + "d0aee9591c237a85c6ad4bf0133a5679.jpg";